<template>
  <div>
    <img src="@/assets/img/lp/20250114_supplementplus_01.jpg" style="border: 1px solid #333;" /><br>
    <img src="@/assets/img/lp/20250114_supplementplus_02.jpg" style="margin-top: 5px; border: 1px solid #333;" />
  </div>
</template>


<style scoped>
</style>

<script>
</script>